// Review carousel for the cart drawer (markup: snippets/tlc-cart-reviews.liquid).
//
// This arrived inside assets/cart-drawer.js, which is stock Horizon — keeping it
// there meant a theme update would overwrite it. It lives on its own now and is
// loaded next to cart-drawer.js from snippets/header-actions.liquid.
//
// The cart drawer is re-rendered from server HTML after every cart change, so
// this element is built to be disposable: all state is per-instance and the
// timer and listeners are cleaned up in disconnectedCallback.
class TLCCartReviews extends HTMLElement {
  connectedCallback() {
    this.index = 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.reducedMotion.matches;
    this.visible = false;
    this.hovered = false;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[data-review-action]');
        if (!button) return;
        if (button.dataset.reviewAction === 'pause') {
          this.paused = !this.paused;
          this.updatePause();
        } else {
          this.show(this.index + (button.dataset.reviewAction === 'next' ? 1 : -1));
        }
      },
      options
    );
    this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
    this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
    this.reducedMotion.addEventListener(
      'change',
      (event) => {
        if (event.matches) { this.paused = true; this.updatePause(); }
      },
      options
    );
    this.observer = new IntersectionObserver((entries) => {
      this.visible = entries.some((entry) => entry.isIntersecting);
    }, { threshold: 0.5 });
    this.observer.observe(this);
    this.timer = setInterval(() => {
      if (
        !this.paused &&
        !this.hovered &&
        this.visible &&
        !this.contains(document.activeElement) &&
        !document.hidden &&
        this.closest('dialog')?.open
      ) {
        this.show(this.index + 1);
      }
    }, 6000);
    this.show(0);
    this.updatePause();
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    this.abort?.abort();
    this.observer?.disconnect();
  }

  updatePause() {
    const button = this.querySelector('[data-review-action="pause"]');
    if (!button) return;
    button.textContent = this.paused ? 'Play' : 'Pause';
    button.setAttribute('aria-label', this.paused ? 'Play review slideshow' : 'Pause review slideshow');
  }

  show(index) {
    const slides = [...this.querySelectorAll('[data-review-slide]')];
    const track = this.querySelector('[data-review-track]');
    if (!slides.length || !track) return;
    this.index = (index + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + this.index * 100 + '%)';
    slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
    const counter = this.querySelector('[data-review-count]');
    if (counter) counter.textContent = this.index + 1 + ' / ' + slides.length;
  }
}

if (!customElements.get('tlc-cart-reviews')) customElements.define('tlc-cart-reviews', TLCCartReviews);
